<template>
  <div class="container">
    <div class="contentContainer">
      <img src="../../assets/common/reportBg.png" alt="" />
      <p>恭喜您完成测试，点击查看，获得评估报告。</p>
      <div class="btnFooter" @click="onCheckReport">点击查看</div>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
export default {
  name: "CheckReport",
  methods: {
    onCheckReport() {
      // // this.$router.push('/phone')
      wx.miniProgram.redirectTo({
        url:
          "/pages/detail/report/report?scene=" +
          this.$store.state.global.globalId,
      });
      // window.open("https://api00.uflycloud.com/zjtest/webreport/?id="+this.$store.state.global.globalId+'&data='+JSON.stringify(this.$store.state.global.wenJuan)+'&type=2');
    },
  },
  mounted() {
    this.$store.state.global.isTrans = false;
  },
};
</script>

<style scoped>
.container {
  background: rgb(237, 241, 248);
}
.contentContainer {
  position: absolute;
  top: 10%;
  left: 3vw;
  width: 94vw;
  height: 90%;
  background: white;
  border-radius: 3vw;
}
img {
  width: 75vw;
  position: absolute;
  left: 50%;
  top: 5%;
  transform: translate(-50%, 0%);
}
p {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, 0%);
  white-space: nowrap;
  font-size: 3vw;
  color: rgb(41, 123, 255);
}
.btnFooter {
  position: absolute;
  left: 50%;
  top: 90%;
  transform: translate(-50%, 0%);

  width: 80vw;
  height: 11vw;
  border-radius: 5vw;
  text-align: center;
  line-height: 11vw;
  font-size: 4vw;
  background: rgb(41, 123, 255);
  color: white;
}
</style>
